export default __webpack_public_path__ + "static/media/no-students.a371e6a5.svg";